export class Page {
  _id: string;
  title: string = '';
  anchor: string = '';
  content: string = '';
  metaDescription: string = '';
  active: boolean = false;
  created: Date;
  updated: Date;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/shared/page.model.ts